import { createNode, DurationDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { toDuration } from '../../utils/temporal';

export const CompareDurations = createNode({
    id: 'Compare Durations',
    name: 'Compare Durations',
    description: 'Compares two Duration values',
    aiDescription:
        'Takes two Duration values on the "First" and "Second" ports and outputs boolean results on "Shorter", "Equal", and "Longer" ports indicating whether the first duration is shorter than, equal to, or longer than the second.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        First: DurationDataType,
        Second: DurationDataType,
    },
    outPorts: {
        Shorter: { kind: 'boolean' },
        Equal: { kind: 'boolean' },
        Longer: { kind: 'boolean' },
    },
    execute: function (input) {
        const first = toDuration(input.inPorts.First);
        const second = toDuration(input.inPorts.Second);
        const comparison = Temporal.Duration.compare(first, second, {
            relativeTo: Temporal.Now.plainDateISO(),
        });
        return {
            output: {
                Shorter: comparison < 0,
                Equal: comparison === 0,
                Longer: comparison > 0,
            },
        };
    },
});
